import React from 'react';

const TimelineView = ({ logs, loading, darkMode }) => {
  if (loading) {
    return <div className="loading">Loading timeline...</div>;
  }

  if (!logs || logs.length === 0) {
    return <div className="empty-state">No activity found</div>;
  }

  // Group logs by date
  const groupedLogs = logs.reduce((acc, log) => {
    const date = new Date(log.timestamp).toLocaleDateString();
    if (!acc[date]) acc[date] = [];
    acc[date].push(log);
    return acc;
  }, {});

  const activityTypeColors = {
    login: '#10b981',
    logout: '#ef4444',
    prompt_generation: '#3b82f6',
    baiql_execution: '#8b5cf6',
    file_upload: '#f59e0b',
    settings_change: '#6366f1',
    credit_usage: '#ec4899',
    team_invitation: '#14b8a6',
    api_key_created: '#84cc16',
    api_key_deleted: '#f97316'
  };

  return (
    <div className={`timeline-view ${darkMode ? 'dark-mode' : ''}`}>
      <div className="timeline-container">
        {Object.entries(groupedLogs).map(([date, dateLogs]) => (
          <div key={date} className="timeline-day">
            <div className="timeline-date">{date}</div>
            <div className="timeline-events">
              {dateLogs.map((log, index) => (
                <div
                  key={log.id || index}
                  className="timeline-event"
                  style={{
                    borderLeftColor: activityTypeColors[log.activityType] || '#6b7280'
                  }}
                >
                  <div className="timeline-event-time">
                    {new Date(log.timestamp).toLocaleTimeString()}
                  </div>
                  <div className="timeline-event-type">{log.activityType}</div>
                  {log.activityDetails && (
                    <div className="timeline-event-details">
                      {typeof log.activityDetails === 'string'
                        ? log.activityDetails
                        : JSON.stringify(log.activityDetails)}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TimelineView;

